import PopNotificationsProvider from './PopNotifications.provider';

export default PopNotificationsProvider;